module.exports = __webpack_public_path__ + "assets/img/crayon14.19af9ed9.png";